import { CanActivate } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from '../services/auth.service';
import {
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Router,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { User } from 'src/app/shared/model';

@Injectable()
export class LoggedInGuard implements CanActivate {
    path: ActivatedRouteSnapshot[];
    route: ActivatedRouteSnapshot;
    constructor(private auth: AuthService, private router: Router) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | boolean {
        const currentUser: User = this.auth.currentUserValue;
        if (currentUser) {
            let testMode = sessionStorage.getItem('test') == 'true';
            if(route.data.testEnabled && testMode)
                return true;
            if (
                route.data.roles &&
                route.data.roles.indexOf(currentUser.role) === -1
            ) {
                this.navigateToLoginPage(state.url);
                return false;
            }

            return true;
        } else {
            this.navigateToLoginPage(state.url);
            return false;
        }
    }

    private navigateToLoginPage(url: string) {
        this.router.navigate(['/login'], {
            queryParams: {
                return: url,
            },
        });
    }
}
